import { NJSpinner } from '@engie-group/fluid-design-system-react';

export interface LoadingProps {
    text: string | undefined;
    scale: 'lg' | 'md' | 'sm' | 'xs' | '2xs';
    'data-testid'?: string;
}

export default function Loading({
    text,
    scale,
    'data-testid': testId,
}: LoadingProps) {
    return (
        <div className="container row" data-testid={testId}>
            <div className="m-2">{text}</div>&nbsp;
            <div>
                <NJSpinner scale={scale} isLoading />
            </div>
        </div>
    );
}
